import React from 'react';
import { Grid } from '@material-ui/core';

function EirClearCart(props) {
    const clearCart = () => {
        localStorage.removeItem('prospectUuid');
        localStorage.removeItem('offerId');
        localStorage.removeItem('plan-name');
        localStorage.removeItem('handset-name');
        localStorage.removeItem('prepayHandsetId');
        localStorage.removeItem('IONOrderReference');
        localStorage.removeItem('planToggle');
        window.location.reload();
    };
    return (
        <Grid container>
            <Grid item sm={12} className='clear-cart'>
                <a onClick={clearCart}>{props.label}</a>
            </Grid>
        </Grid>
    );
}
export default EirClearCart;
